import { useEffect, useState } from "react";
import { AdContextData } from "@foundation/sparkle/lib/types";

import { Story as StoryType } from "~types/types";

function resetAdContext(adContextData: AdContextData) {
    window.Sparkle.cmd.push(() => {
        window.Sparkle.resetAdContext(adContextData);
    });
}

const useResetAdContext = (isInViewport: boolean, story: StoryType) => {
    const [prevIsInViewport, setPrevIsInViewport] = useState(isInViewport);

    useEffect(() => {
        if (isInViewport && !prevIsInViewport) {
            resetAdContext({ adPageType: "article", slug: story.slug });
        }

        if (isInViewport !== prevIsInViewport) {
            setPrevIsInViewport(isInViewport);
        }
    }, [isInViewport, prevIsInViewport, setPrevIsInViewport, story.slug]);
};

export default useResetAdContext;
